import React from "react";
import {makeFitImageUrl, makeCustomImageUrl} from "../../../utils";
import Login1 from "../../../assets/img/login1.jpg";

class ChannelPublicNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channel: props.channel
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.channel) {
      this.setState({channel: nextProps.channel})
    }
  }

  render() {
    const {channel} = this.state

    return (
      <>
      {channel.id &&
        <nav className="navbar" style={{position: "relative", boxShadow: "none", zIndex: 0, height: 77}}>
          <div style={{
            height: "100vh",
            width: "100%", transform: "scale(1.1)",
            overflow: "hidden",
            position: " fixed",
            filter: "blur(5px)",
            background: `url(${channel.loginImage ? makeCustomImageUrl(channel.loginImage, 1920, 1080) : Login1}) no-repeat center center fixed`,
            backgroundSize: "cover"
          }}
          />
          <div className="navbar-image-container" style={{marginLeft: "40px"}}>
            <div className="navbar-image-container">
              <a className="navbar-image-container-link" href={'#'}>
                {channel.image &&
                <React.Fragment>
                  <img className="navbar-image" style={{filter: "grayscale(1)"}}
                       src={(makeFitImageUrl(this.state.channel, 400, 50, '', 'png'))}
                       alt="Logo"/>
                </React.Fragment>
                }
              </a>
            </div>
          </div>
        </nav>
      }
      </>
    )
  }
}

export default ChannelPublicNavBar
